import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const DoneLight = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <path
        fill="#FCFCFD"
        d="M6 10.8 3.668 8.468a.656.656 0 0 0-.933 0 .656.656 0 0 0 0 .934l2.793 2.793c.26.26.68.26.94 0l7.067-7.06a.656.656 0 0 0 0-.933.656.656 0 0 0-.933 0z"
      />
    </svg>
  );
};
export default DoneLight;
